var _circle, _g, _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 16,
    fill: "#FFD700",
    stroke: "#C68642",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 14,
    fill: "#fffbe7",
    stroke: "#FFD700",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8,
    r: 2,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 40,
    r: 2,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 24,
    r: 2,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 2,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 2,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 13,
    r: 2,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 35,
    r: 2,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 2,
    fill: "#FFD700"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#1976D2",
    stroke: "#1976D2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20,44 24,48 28,44",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.e806a94008ac78517239500d0e228cad.svg";
export { ForwardRef as ReactComponent };